export default "__VITE_ASSET__BVGz7oeK__"